import { render } from "./footer.vue?vue&type=template&id=e6bf65d8&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=e6bf65d8&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6bf65d8"]])

export default __exports__